import React, { useState } from "react";
import { makeStyles, LinearProgress, Box } from "@material-ui/core";

const PasswordStrengthBar = ({ passwordStrength }) => {
  const useStyles = makeStyles(theme => ({
    linearProgress: {
      "& .MuiLinearProgress-barColorPrimary": {
        backgroundColor:
          passwordStrength?.strength >= 60 ? "#039A6C" : "#9A031E",
      },
    },
  }));

  const classes = useStyles();

  return (
    <Box>
      <LinearProgress
        variant="determinate"
        style={{
          // width: "100%",
          height: 10,
          borderRadius: 5,
          marginTop: 2,
          marginBottom: 2,
          backgroundColor:
            passwordStrength?.strength?.toFixed(2) >= 60
              ? "#3BA950aa"
              : "#A94438aa",
        }}
        value={Math.min(passwordStrength?.strength || 0, 100)}
        className={classes.linearProgress}
      />
    </Box>
  );
};

export default PasswordStrengthBar;
